import {FC, useEffect} from 'react'
import {useCurrentRoute} from '@/hooks/useCurrentRoute'
import {useLocation} from 'react-router-dom'

export const withTitle = (Component: FC) => {
  return props => {
    const currentRoute = useCurrentRoute();
    const location = useLocation();

    useEffect(() => {
      document.title = currentRoute.handle?.title || '客服中心';
    }, [location.pathname]);

    return <Component {...props} />
  }
}
